export enum ERROR_AUTH {
  EMAIL_IS_REGISTERED = "Email is already registered",
  PHONE_IS_REGISTERED = "Phone is already registered",
  EMAIL_IS_NOT_REGISTERED = "Email is not registered yet",
  PHONE_IS_NOT_REGISTERED = "Phone is not registered yet",
  ERROR_OTP = "Invalid OTP or OTP is already expired!",
}
